<template>
  <div class="flex-grow-1" :class="{ 'mt-3': kr.isArchived }">
    <archived-bar v-if="kr.isArchived" class="kr-activity-modal-archive-bar text-normal" />
    <div class="d-flex row-item">
      <div class="icon-container flex-center">
        <i class="goal-icon flex-shrink-0"></i>
      </div>
      <div class="ml-2 text-large bold" v-no-capture>
        {{ goal.title }}
      </div>
    </div>
    <div class="d-flex justify-content-between flex-grow-1 row-item">
      <div class="d-flex">
        <div class="icon-container flex-center">
          <i class="kr-icon flex-shrink-0 mt-1"></i>
        </div>
        <div class="ml-2 text-normal-1 bold" v-no-capture>
          {{ kr.title }}
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between flex-grow-1 row-item">
      <div class="d-flex flex-grow-1">
        <div class="icon-container flex-center">
          <i class="initiative-icon flex-shrink-0"></i>
        </div>
        <div
          class="ml-2 text-medium-1 d-flex justify-content-between flex-grow-1 align-items-center"
        >
          <div><span class="bold">Initiatives</span> (Generated by AI)</div>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArchivedBar from '@/components/ArchivedBar'
import { VARIANT_MAP } from '@/constants/common'
import { calculateCompletionPercent } from '@/utils/calculateCompletionPercent'
import { getGoalPageRouteConfig, getKrPageRouteConfig } from '@/utils/navigationConfigs'
import { mapActions } from 'vuex'

/**
 * This shows the hierarchy of initiative
 *  Goal title
 *  |
 *  KR title
 *  |
 *  Initiatives
 */
export default {
  name: 'InitiativeHierarchy',
  props: ['kr'],
  components: {
    ArchivedBar
  },
  computed: {
    ...mapActions(['getGoal']),
    goal() {
      return this.$store.getters.goalById(this.kr.goalId)
    },
    krPageLocation() {
      return getKrPageRouteConfig({
        orgId: this.kr.organizationId,
        krId: this.kr.id
      })
    },
    goalPageLocation() {
      return getGoalPageRouteConfig({
        orgId: this.kr.organizationId,
        goalId: this.kr.goalId
      })
    },
    completedPercent() {
      const { current, start, end } = this.kr
      return calculateCompletionPercent(start, end, current)
    },
    colorVariant() {
      return VARIANT_MAP['outcome-' + this.kr.outcome] || VARIANT_MAP['status-' + this.kr.status]
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.kr-activity-modal-archive-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  font-weight: normal;
}
.icon-container {
  @include dimension(19px, 19px);
}
.kr-icon {
  @include dimension(12px, 14px);
  background-size: contain;
  background-position: center;
}
.initiative-icon {
  @include dimension(15px, 15px);
  margin-top: 6px;
}
.goal-icon {
  @include dimension(16px, 16px);
  background-size: cover;
  margin-top: 11px;
}
.row-item {
  position: relative;
  padding-bottom: 16px;
}
.row-item:not(:last-child) .icon-container {
  &:before {
    content: '';
    width: 1px;
    display: inline-block;
    background-color: $tertiary;
    position: absolute;
    left: 9px;
    top: 26px;
    bottom: 0;
  }
}
</style>
